export default {"src":"/_next/static/media/LinkIcon.9667874b.svg","height":24,"width":24};